import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Default config — shown while loading or if API is unreachable
const DEFAULT_CONFIG = {
  platform_name: 'Constellation Cloud',
  platform_tagline: 'Secure. Distributed. Resilient.',
  support_email: 'support@constellationcloud.local',
  ssh_hostname: 'ssh.constellationcloud.local',
  s3_endpoint: 'https://s3.constellationcloud.local',
  nats_public_url: 'nats://nats.constellationcloud.local:4222',
  nodes_domain: 'nodes.constellationcloud.local',
  ns1_hostname: 'ns1.constellationcloud.local',
  ns2_hostname: 'ns2.constellationcloud.local',
  enable_billing: false,
  enable_marketplace: true,
  allow_registration: true,
  require_invite_code: false,
};

let cachedConfig = null;

export function usePlatformConfig() {
  const [config, setConfig] = useState(cachedConfig || DEFAULT_CONFIG);
  const [loading, setLoading] = useState(!cachedConfig);

  useEffect(() => {
    if (cachedConfig) return;
    fetch(`${API_URL}/v1/platform/config`)
      .then(r => r.json())
      .then(data => {
        cachedConfig = { ...DEFAULT_CONFIG, ...data };
        setConfig(cachedConfig);
        setLoading(false);
        // Set document title from platform name
        document.title = data.platform_name || DEFAULT_CONFIG.platform_name;
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return { config, loading };
}

// Helper: build node hostname from instance ID
export function nodeHostname(instanceId, nodesDomain) {
  return `${instanceId.substring(0, 8)}.${nodesDomain}`;
}

// Helper: build SSH command for an instance
export function sshCommand(sshPort, sshHostname) {
  return `ssh -p ${sshPort} ubuntu@${sshHostname}`;
}
